import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { SharedService } from "./shared.service";

@Injectable()
export class EventService {
    public getEventPublicApi: string = "/svcs/session_catalog/app/event/findByUUID";
    public getEventByUUIDApi: string = "/svcs/events/findByUUID";

    constructor(private http: HttpClient, public sharedService: SharedService) {}

    public getEventByUUID(uuid: string) {
        let url;
        if (this.sharedService.redirectTo == "admin") {
            url = this.getEventByUUIDApi;
        } else {
            url = this.getEventPublicApi;
        }
        return this.http.get(url, {
            params: new HttpParams().set("uuid", uuid),
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public getFormsByUUID(eventUUID: string, pageId: number) {
        return this.http.get("/svcs/forms/list", {
            params: new HttpParams().set("eventUUID", eventUUID).set("pageId", pageId.toString()),
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public getEventSSOList(eventId: number) {
        return this.http.get("/svcs/sso/event_config", {
            params: new HttpParams().set("eventId", eventId.toString()),
            observe: "response",
            headers: this.sharedService.headers
        });
    }
}
